import { z } from 'zod'

import { Pagination } from 'app/types/app/request'
import { Category } from 'app/types/catalogue/category'

/** Manager of the Konvives and clients. */
export const Manager = z.object({
    id: z.number().positive(),
    name: z.string().min(1),
    category: Category,
    email: z.string().email(),
    phone: z.string().min(1).max(13),
    email_help: z.string().email().nullable(),
    phone_help: z.string().max(13).nullable(),
    has_order: z.boolean(),
    has_icoupon: z.boolean(),
})

export type Manager = z.infer<typeof Manager>

/** Manager inside linked objects. */
export const ManagerBinding = Manager.pick({
    id: true,
    name: true,
})

export type ManagerBinding = z.infer<typeof ManagerBinding>

/** Form data to create or update a manager. */
export const ManagerPayload = Manager.omit({
    id: true,
}).extend({
    category: Category.shape.id,
})

export type ManagerPayload = z.infer<typeof ManagerPayload>

export const ManagersRequest = Pagination.extend({
    results: Manager.array(),
})

export type ManagersRequest = z.infer<typeof ManagersRequest>
